
    import './styles.scoped.css';
    export default {
  "dropdown-content-wrapper": "awsui_dropdown-content-wrapper_qwoo0_1h92k_3",
  "awsui-motion-fade-in-dropdown": "awsui_awsui-motion-fade-in-dropdown_qwoo0_1h92k_1",
  "refresh": "awsui_refresh_qwoo0_1h92k_24",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_qwoo0_1h92k_1",
  "root": "awsui_root_qwoo0_1h92k_49",
  "interior": "awsui_interior_qwoo0_1h92k_60",
  "dropdown": "awsui_dropdown_qwoo0_1h92k_3",
  "use-portal": "awsui_use-portal_qwoo0_1h92k_71",
  "dropdown-drop-up": "awsui_dropdown-drop-up_qwoo0_1h92k_116",
  "with-limited-width": "awsui_with-limited-width_qwoo0_1h92k_120",
  "dropdown-drop-left": "awsui_dropdown-drop-left_qwoo0_1h92k_123",
  "dropdown-drop-right": "awsui_dropdown-drop-right_qwoo0_1h92k_126",
  "occupy-entire-width": "awsui_occupy-entire-width_qwoo0_1h92k_129",
  "hide-upper-border": "awsui_hide-upper-border_qwoo0_1h92k_132",
  "open": "awsui_open_qwoo0_1h92k_139",
  "nowrap": "awsui_nowrap_qwoo0_1h92k_148",
  "is-empty": "awsui_is-empty_qwoo0_1h92k_152",
  "dropdown-content": "awsui_dropdown-content_qwoo0_1h92k_3",
  "ie11-wrapper": "awsui_ie11-wrapper_qwoo0_1h92k_162",
  "stretch-trigger-height": "awsui_stretch-trigger-height_qwoo0_1h92k_166"
};
  